import React, { useEffect, useState } from 'react';

import infracoes_api from '../../../../api/infracoes_api';

// Components
import CartaoFicha from './CartaoFicha';
import RodapeEmissor from './RodapeEmissor';
import AvisoItemSemConteudo from './AvisoItemSemConteudo';

// Mesmo motor de BoletoInfracao/SolicitarBoletoPng: o backend rasteriza o PDF em PNG por página, e
// aqui é <img> — sem o visualizador nativo de PDF do navegador dentro da impressão completa.
export default function ItemPdf({ hash, parametrizacaoHash, titulo, numeroInfracao, onReady }) {
    const [paginas, setPaginas] = useState(null);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        infracoes_api.GetImpressaoItemPngCompleta(hash, parametrizacaoHash)
            .then(({ data }) => {
                if (data?.length)
                    setPaginas(data);
                else
                    setErro("Não foi possível gerar este documento.");
            })
            // Item sem conteúdo sumia calado da impressão: o usuário imprimia achando que veio tudo.
            .catch(error => setErro(error?.message ?? "Não foi possível gerar este documento."))
            .finally(onReady);
    }, [hash, parametrizacaoHash]);

    if (erro) return <AvisoItemSemConteudo titulo={titulo} mensagem={erro} />;

    if (!paginas) return null;

    return (
        <> 
            {paginas.map((base64, index) => (
                <CartaoFicha key={index} titulo={titulo ?? "Documento"} className="break mb-3">
                    <div className="d-flex justify-content-center mt-3">
                        <img
                            className="paginaPdfCompleta"
                            src={`data:image/png;base64,${base64}`}
                            alt={`${titulo ?? "Documento"} - página ${index + 1}`}
                            style={{ width: "100%", maxWidth: "750px", height: "auto", objectFit: "contain" }}
                        />
                    </div>
                    <RodapeEmissor numeroInfracao={numeroInfracao} />
                </CartaoFicha>
            ))}
        </>
    );
}
